// extracted by mini-css-extract-plugin
export default {"root":"BulkModal_root__Uhk4t","checkboxContainer":"BulkModal_checkboxContainer__S5wuM"};